import { render, staticRenderFns } from "./FilterableColumns.vue?vue&type=template&id=ab65d2be&"
import script from "./FilterableColumns.vue?vue&type=script&lang=js&"
export * from "./FilterableColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports